import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import * as Icons from 'lucide-react';
import { Section } from '../ui/Section';
import { Card } from '../ui/Card';
import { services } from '../../data/mock';
import { LucideIcon } from 'lucide-react';

export const ServicesGrid = () => {
  return (
    <Section background="gray">
      <div className="text-center max-w-3xl mx-auto mb-16">
        <h2 className="text-secondary font-bold uppercase tracking-widest mb-2 text-sm">Naše Usluge</h2>
        <h3 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
          Kompletna Rešenja za <br />
          <span className="text-primary">Vaš Dom i Poslovni Prostor</span>
        </h3>
        <p className="text-gray-600">
          Od proizvodnje do ugradnje, nudimo širok spektar usluga prilagođenih vašim potrebama.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {services.map((service) => {
          // Dynamic icon rendering
          const IconComponent = (Icons as any)[service.icon] as LucideIcon;

          return (
            <Link key={service.id} to={service.path} className="group">
              <Card className="h-full p-6 flex flex-col hover:border-secondary/30">
                <div className="w-12 h-12 bg-primary/5 rounded-lg flex items-center justify-center mb-6 group-hover:bg-primary group-hover:text-white transition-colors">
                  {IconComponent && <IconComponent size={24} />}
                </div>
                
                <h4 className="text-xl font-bold mb-3 text-gray-900 group-hover:text-primary transition-colors">
                  {service.title}
                </h4>
                
                <p className="text-gray-600 text-sm mb-6 flex-grow leading-relaxed">
                  {service.description}
                </p>

                <div className="flex items-center text-secondary font-medium text-sm group-hover:translate-x-1 transition-transform">
                  Detaljnije <ArrowRight size={16} className="ml-1" />
                </div>
              </Card>
            </Link>
          );
        })}
      </div>
    </Section>
  );
};
